import { LOCAL_STORAGE_KEY_JWT } from '@/api'
import { sendMessageToExtension } from '@/utils'
import { useLocalStorage } from '@/utils/useLocalStorage'
import { useCallback } from 'react'

const getEmailFromJwt = (jwt: string): string => {
  try {
    const payload = jwt.split('.')[1]
    const decoded = JSON.parse(atob(payload))
    return decoded.sub || decoded.email || '-'
  } catch {
    return '-'
  }
}

export const useAuthComplete = () => {
  const [, setJwt] = useLocalStorage(LOCAL_STORAGE_KEY_JWT, '')

  const complete = useCallback(
    async (jwt: string, inviteCode?: string) => {
      setJwt(jwt)

      const email = getEmailFromJwt(jwt)
      try {
        await sendMessageToExtension<void>('login', { email, jwt })
      } catch (error) {
        console.error('Failed to sync with extension:', error)
      }

      const redirectUrl = inviteCode ? `/?invite=${inviteCode}` : '/'
      window.location.replace(redirectUrl)
    },
    [setJwt]
  )

  return { complete }
}
